<template>
	<div class="flex flex-wrap gap-x-6 gap-y-4">
		<!-- if we use this component also in another (not offer edit) context,
             we should allow columns to be flexible, for example, by passing ZIPclass parameter. -->
		<ui-input-group
			class="basis-full md:basis-[calc(33.333%-1rem)]"
			v-model="address.zip"
			:field="fieldName('address.zip')"
			label="ZIP"
			:form="form"
			:required="true"
			@change="onZipChange"
		>
		</ui-input-group>

		<ui-input-group
			class="basis-full md:basis-[calc(33.333%-1rem)]"
			v-model="address.city"
			:field="fieldName('address.city')"
			label="City"
			:form="form"
			:required="true"
			:key="'CITY_INPUT.' + hack"
		></ui-input-group>

		<ui-select-group
			class="basis-full md:basis-[calc(33.333%-1rem)]"
			v-model="address.country"
			type="select"
			:field="fieldName('address.country')"
			label="Country"
			:options="$cropOptions.countryOptions"
			:form="form"
			:required="true"
			:placeholder="false"
			:key="'COUNTRY_INPUT.' + hack"
		></ui-select-group>

		<div class="basis-full text-red-600" v-if="markInvalid">
			{{ validationMessage }}
		</div>
	</div>
</template>

<script>
export default {
	props: {
		value: {
			type: Object,
			required: true,
		},
		prefix: {
			type: String,
			default: "",
		},
		form: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			address: Vue.observable(this.value),
			cityOptions: [],
			hack: this._uid,
		};
	},
	computed: {
		formField() {
			let f = (this.prefix ? this.prefix + "." : "") + "address";
			return f;
		},
		markInvalid() {
			return this.form.hasErrors && this.form.errors[this.formField] != null;
		},
		validationMessage() {
			return this.form.errors[this.prefix + ".address"] || "";
		},
	},
	methods: {
		fieldName(name) {
			return this.prefix ? this.prefix + "." + name : name;
		},
		onZipChange() {
			this.fetchCitySuggestion();
			this.triggerReload();
		},

		fetchCitySuggestion() {
			let zip = ("" + this.address.zip).trim(),
				that = this;
			if (
				zip.length == 5 &&
				!isNaN(zip) &&
				(!this.address.country || this.address.country === "DE")
			) {
				// valid german zip — only autocomplete when country is DE or unset
				axios
					.get(this.$route("zip.search"), {
						params: {
							zip: zip,
						},
					})
					.then(function (response) {
						let d = response.data.data[0];
						if (d) {
							that.address.city = d.name;
							that.address.country = "DE";
						} else {
							that.address.city = '';
						}
						that.hack++;
					});
			}
		},
		validationEventListener() {
			let that = this;
			console.log("is-mark-invalid", that.field, that.markInvalid);
			that.$bus.$emit("is-mark-invalid", that.field, that.markInvalid);
		},
		triggerReload() {
			if ("parentIFrame" in window) {
				window.parentIFrame.sendMessage("FULL_RELOAD");
			}
		},
	},
	created() {
		this.$bus.$on("poll-is-mark-invalid", this.validationEventListener);
	},
	beforeDestroy() {
		console.log("TURNING OFF", this.field);
		this.$bus.$off("poll-is-mark-invalid", this.validationEventListener);
	},
};
</script>
